import { render, staticRenderFns } from "./KnowledgeBaseDocumentItem.vue?vue&type=template&id=896e56e6&scoped=true"
import script from "./KnowledgeBaseDocumentItem.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseDocumentItem.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseDocumentItem.vue?vue&type=style&index=0&id=896e56e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e56e6",
  null
  
)

export default component.exports